import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const activityRoutes: RouteRecordRaw[] = [
  {
    path: '/activity',
    name: 'Activity',
    component: Layout,
    meta: {
      title: '活动中心',
      icon: 'mdi-calendar-star-outline',
      alwaysShow: true
    },
    children: [
      {
        path: 'ticket-diamond',
        name: 'ActivityTicketDiamond',
        component: getParentLayout(),
        meta: {
          title: '挑战卡钻石',
          icon: 'mdi-diamond-stone',
          alwaysShow: true
        },
        children: [
          {
            path: 'issue',
            name: 'TicketIssue',
            component: () => import('@/views/Admin/Ticket/Issue.vue'),
            meta: {
              title: '模板管理',
              icon: 'mdi-card-bulleted-outline'
            }
          },
          {
            path: 'diamond-details',
            name: 'DiamondDetails',
            component: () => import('@/views/Admin/Ticket/DiamondDetails.vue'),
            meta: {
              title: '钻石明细',
              icon: 'mdi-diamond-outline'
            }
          },
          {
            path: 'list',
            name: 'TicketList',
            component: () => import('@/views/Admin/Ticket/List.vue'),
            meta: {
              title: '挑战卡列表',
              icon: 'mdi-ticket'
            }
          },
          {
            path: 'record',
            name: 'TicketRecord',
            component: () => import('@/views/Admin/Ticket/Record.vue'),
            meta: {
              title: '挑战卡记录',
              icon: 'mdi-clipboard-list-outline'
            }
          },
          {
            path: 'diamond-records',
            name: 'DiamondRecords',
            component: () => import('@/views/Admin/Ticket/DiamondRecords.vue'),
            meta: {
              title: '钻石记录',
              icon: 'mdi-diamond-stone'
            }
          }
        ]
      },
      {
        path: 'config',
        name: 'ActivityConfig',
        component: getParentLayout(),
        meta: {
          title: '活动配置',
          icon: 'mdi-cog-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'season',
            name: 'TicketSeason',
            component: () => import('@/views/Admin/Ticket/Season/List.vue'),
            meta: {
              title: '赛季管理',
              icon: 'mdi-calendar-month-outline'
            }
          },
          {
            path: 'game-reward',
            name: 'GameRewardList',
            component: () => import('@/views/Admin/GameReward/List.vue'),
            meta: {
              title: '游戏奖励',
              icon: 'mdi-gift'
            }
          },
          {
            path: 'offline-activity',
            name: 'GameRewardOfflineActivity',
            component: () => import('@/views/Admin/GameReward/OfflineActivity/List.vue'),
            meta: {
              title: '线下活动',
              icon: 'mdi-calendar-star'
            }
          },
          {
            path: 'final-claim-config',
            name: 'FinalClaimConfig',
            component: () => import('@/views/Admin/GameReward/FinalClaimConfig/List.vue'),
            meta: {
              title: '决赛领取配置',
              icon: 'mdi-trophy-outline'
            }
          },
          {
            path: 'reward-record',
            name: 'GameRewardRecord',
            component: () => import('@/views/Admin/GameReward/RewardRecord/List.vue'),
            meta: {
              title: '发奖记录',
              icon: 'mdi-clipboard-text-outline'
            }
          }
        ]
      },
      {
        path: 'battle-record',
        name: 'ActivityBattleRecord',
        component: getParentLayout(),
        meta: {
          title: '对战记录',
          icon: 'mdi-sword-cross',
          alwaysShow: true
        },
        children: [
          {
            path: 'callback',
            name: 'ActivityBattleCallback',
            component: () => import('@/views/Admin/Game/Battle.vue'),
            meta: {
              title: '回调记录',
              icon: 'mdi-swap-horizontal'
            }
          },
          {
            path: 'challenge',
            name: 'ActivityBattleChallenge',
            component: () => import('@/views/Admin/Game/Challenge.vue'),
            meta: {
              title: '挑战记录',
              icon: 'mdi-trophy-outline'
            }
          }
        ]
      },
      {
        path: 'cdk',
        name: 'ActivityCdk',
        component: getParentLayout(),
        meta: {
          title: 'CDK管理',
          icon: 'mdi-ticket-confirmation-outline',
          alwaysShow: true
        },
        children: [
          {
            path: 'list',
            name: 'TicketCdkList',
            component: () => import('@/views/Admin/Ticket/Cdk/List.vue'),
            meta: {
              title: 'CDK动态码',
              icon: 'mdi-barcode'
            }
          },
          {
            path: 'fixed',
            name: 'TicketCdkFixedList',
            component: () => import('@/views/Admin/Ticket/Cdk/Fixed/List.vue'),
            meta: {
              title: '固定口令',
              icon: 'mdi-key-variant'
            }
          },
          {
            path: 'fixed-log',
            name: 'TicketCdkFixedLog',
            component: () => import('@/views/Admin/Ticket/Cdk/Fixed/Log.vue'),
            meta: {
              title: '固定口令日志',
              icon: 'mdi-clipboard-text-clock-outline',
              hidden: true
            }
          },
          {
            path: 'log',
            name: 'TicketCdkLog',
            component: () => import('@/views/Admin/Ticket/Cdk/Log.vue'),
            meta: {
              title: '兑换日志',
              icon: 'mdi-clipboard-text-clock-outline'
            }
          }
        ]
      }
    ]
  }
]

export default activityRoutes
